// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".wpcm-settings-editor {\n  margin-top: 20px;\n}", "",{"version":3,"sources":["webpack://./src/js/wpcm/fields/Editor.vue"],"names":[],"mappings":"AACA;EACE,gBAAA;AAAF","sourcesContent":["\r\n.wpcm-settings-editor {\r\n  margin-top: 20px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
